import React from 'react';

// a little bit of anti pattern here and there.

const forceRerenderParent = (BaseComponent) => class extends React.Component {
  componentDidUpdate() {
    const { parentForceRerender } = this.props;

    if (parentForceRerender) {
      parentForceRerender();
    }
  }

  render() {
    const { parentForceRerender, ...restProps } = this.props;
    return <BaseComponent {...restProps} />;
  }
};

export default forceRerenderParent;



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/forceRerenderParent.js